import { render, staticRenderFns } from "./AuthActionMenu.vue?vue&type=template&id=d3ddc5f0&"
import script from "./AuthActionMenu.vue?vue&type=script&lang=ts&"
export * from "./AuthActionMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports